// src/utils/constants.js

// Booking status values
export const BOOKING_STATUS = [
  "Pending",
  "Confirmed",
  "Cancelled",
  "Payment Done Booking Failed",
  "Payment Failed",
  "Booking Confirmed Ticket Failed",
  "Full Canc. In Process",
  "Partial Canc. In Process",
  "Cancellation In Process",
  "Refund Processed",
  "AIrlines Response Awaited",
  "Ssr",
  "Cancellation Quotation",
  "Reissue Quotation",
  "Re-Issue",
  "Fare Change",
  "Miscellaneous",
  "No Show",
  "Void",
  "Correction",
  "Ticket Pending",
  "Booking Pending",
  "Booking Aborted",
  "Session Expired",
  "Others",
];
